module.exports = __webpack_public_path__ + "img/mailamericas-logo.d5c8b0d3.png";